import { SaveUsersFilter } from '@shared/classes/users/SaveUsersFilter';
import { GetUsersFilter } from '@shared/classes/users/GetUsersFilter';

export interface FilterManageState {
  filter: SaveUsersFilter;
  savedFilters: GetUsersFilter[];
}

export const filterManageInitialState = {
  filter: undefined,
  savedFilters: undefined,
};
